import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertJpgToBmp() {
  return <ImageConverterTemplate sourceFormat="JPG" targetFormat="BMP" acceptTypes=".jpg,.jpeg,image/jpeg" slug="convert-jpg-to-bmp" gradientColors="from-green-500 to-emerald-600" accentColor="green" />;
}
